<template>
  <div class="tableHistorico">
    <div v-show="this.$store.getters.$GetModalCancel.itemChecklist">
      <ModalEdit :list="listEdit" />
    </div>
    <table>
      <thead>
        <tr>
          <td style="border-top-left-radius: 10px">Descrição</td>
          <td>Data de Criação</td>
          <td>Ultima Atualização</td>
          <td style="border-top-right-radius: 10px">Opção</td>
          <!-- <td style="border-top-right-radius: 10px">OPÇÕES</td> -->
        </tr>
      </thead>
      <tbody v-for="l in listItems" :key="l.id">
        <tr>
          <td style="display: none"></td>
          <td data-title="Descrição">{{ l.DESC }}</td>
          <td data-title="Data de Criação">{{ ReformDate(l.created_at) }}</td>
          <td data-title="Ultima Atualização">
            {{ ReformDate(l.updated_at) }}
          </td>
          <td data-title="Opção">
            <div class="buttons-group">
              <button class="button" @click="editItem(l)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="button2" @click="deleteItem(l.ID)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ModalEdit from "../../../components/Modais/ModalItemsChecklist/modules/edit.vue";
import { GetFindAllDataItem } from "../../../controllers/ItemsChecklist/GetFindAllDataItem";
import { DeleteDataItem } from "../../../controllers/ItemsChecklist/DeleteDataItem";
import ModalLayout from "../../../components/Modais/ModalLayoutExtracao/index.vue";
export default {
  components: { ModalLayout, ModalEdit },
  async created() {
    const result = await GetFindAllDataItem();
    if (result != undefined) {
      this.$store.commit("SetListItems", result.data.list);
    }
  },
  data() {
    return {
      modalview: false,
      listEdit: [],
    };
  },
  computed: {
    listItems() {
      return this.$store.state.listItems;
    },
  },
  methods: {
    ReformDate(date) {
      const data = new Date(date);
      let dia = ("0" + data.getDate()).slice(-2);
      let mes = ("0" + (data.getMonth() + 1)).slice(-2);
      let ano = data.getFullYear();

      return `${dia}/${mes}/${ano}`;
    },
    async editItem(list) {
      this.listEdit = list;
      this.$store.commit("MutationSetCancelModaItemCheckllist", true);
    },
    async deleteItem(id) {
      const toast = await this.$swal
        .fire({
          title: "Deseja deletar Item?",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            return true;
          }

          return false;
        });

      if (!toast) {
        return;
      }

      const res = await DeleteDataItem(id);
      if (res.status == 201) {
        const Toast = await this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        const result = await GetFindAllDataItem();
        if (result != undefined) {
          this.$store.commit("SetListItems", result.data.list);
        }

        Toast.fire({
          icon: "success",
          title: res.data.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.card {
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  padding: 25px;
  overflow-x: scroll;
  border-radius: 12px;
  box-shadow: 0 0.15rem 1.75rem 0 rgb(58 59 69 / 15%) !important;
}

.tableHistorico img {
  cursor: pointer;
}

.tableHistorico table {
  font-size: 14px;
}

.viewprocess {
  height: 15vh;
  width: 10vw;
  background-color: var(--white);
  border: none;
  border-radius: 15px;
  color: var(--green);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.viewcont {
  display: flex;
  width: 100%;
}

.buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
}

.button {
  background: var(--btnBlue);
  color: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
}

.button2 {
  background: var(--red);
  color: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
}

.labelborder {
  background: var(--green);
  color: var(--white);
  width: 2vw;
  min-width: 2vw;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 10px;
}

.table {
  width: 100%;
}
table {
  font-family: "Poppins", sans-serif;
}

tr {
  text-align: center;
}

.titleContent {
  margin-top: 30px;
  text-align: center;
  color: var(--gray);
}

.buttons {
  margin-top: 3rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.buttons .btnAnalise {
  width: 85%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* .buttons .solic {
  display: block;
  text-align: center;
  margin: 0 1rem 1rem 0;
  line-height: 2.5rem;
} */

.buttons .btnAnalise > div > h6 {
  color: var(--green);
  font-size: 1rem;
}

/* .tableHistorico {
  width: 100%;
  margin-top: 15px;
  background: var(--white);
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  border-radius: 10px;
} */

.tableHistorico {
  padding: 0;
  margin: 3rem 0;
}

.tableHistorico table {
  width: 100%;
  border-collapse: collapse;
}

.tableHistorico table thead {
  border-top: none;
  border-bottom: none;
  background: var(--green);
  color: var(--white);
}

.tableHistorico table thead td {
  font-weight: 550;
  border-top: none;
  /* border-bottom: 1.5px solid var(--gray); */
  border-bottom: 1.5px solid var(--cinza);
}

.tableHistorico table tbody td {
  /* border-bottom: 1px solid var(--gray); */
  border-bottom: 1.5px solid var(--cinza);
}

.tableHistorico table tr td {
  text-align: center;
  padding: 15px;
}

.tableHistorico table tbody tr:hover {
  background: var(--white);
}
.tableHistorico table tbody .red {
  width: 30px;
  height: 100%;
  background: var(--red);
}
.tableHistorico table tbody .purple {
  width: 30px;
  height: 100%;
  background: var(--purple);
}
.tableHistorico table tbody .orange {
  width: 30px;
  height: 100%;
  background: var(--orange);
}
.tableHistorico table tbody .green {
  width: 30px;
  height: 100%;
  background: var(--green);
}
.tableHistorico table tbody .blue {
  width: 30px;
  height: 100%;
  background: var(--var(--btnBlue));
}
.tableHistorico .btnTable {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tableHistorico .btnTable .btn:first-child {
  margin-bottom: 10px;
}
.tableHistorico .btnTable a {
  text-decoration: none;
}

.button {
  background: var(--white);
  color: var(--blue);
  font-size: 16px;
  /* color: var(--white); */
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button:hover {
  background: var(--blue);
  color: var(--white);
}

.button2 {
  color: var(--red);
  font-size: 16px;
  background: var(--white);
  padding: 6px;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: 0.5s;
}

.button2:hover {
  background: var(--red);
  color: var(--white);
}

@media (max-width: 800px) {
  .buttons .btnAnalise .quad {
    width: 45%;
  }

  .buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 1rem;
  }
  .viewprocess {
    width: 100%;
    padding: 60px 0;
  }

  .buttons .btnAnalise {
    width: 100%;
    gap: 1rem;
  }

  .labelborder {
    width: 20vw;
  }
}

@media (max-width: 768px) {
  .buttons .btnAnalise .quad {
    width: 100%;
  }

  .tableHistorico thead {
    display: none;
  }

  .tableHistorico table {
    border-radius: 10px 10px 0 0;
  }

  .tableHistorico td {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;
  }

  .tableHistorico td:nth-child(2) {
    background-color: var(--cinza);
  }

  .tableHistorico td:first-of-type {
    font-weight: bold;
    font-size: 1.2rem;
    text-align: center;
    display: flex;
    justify-content: center;
  }

  .tableHistorico td:not(:first-of-type):before {
    content: attr(data-title);
    display: block;
    font-weight: bold;
  }
}
</style>
